<template>
  <div class="footer-n">
    <div class="footer-container">
      <div class="footer-top">
        <div class="footer-top-left">
          <div class="logo">
            <img src="@/assets/logo-blue.svg" alt="MusicVerse Logo" />
          </div>
          <div class="footer-links">
            <div class="ft-group">
              <div class="footer-nav">
                <span class="fn-title">Company</span>
                <a @click="toAbout" aria-label="About Us"> About Us </a>
                <a :href="`${mv_url}/blog`" aria-label="Blog">Blog</a>
              </div>
              <div class="footer-nav">
                <span class="fn-title">COMMUNITY</span>
                <a aria-label="For Musicians" @click="toMusicians">
                  For Musicians
                </a>
                <a
                  :href="`/#/donation-page`"
                  aria-label="Missions Project"
                >Missions Project
                </a>
              </div>
            </div>
            <div class="ft-group">
              <div class="footer-nav">
                <span class="fn-title">RESOURCE</span>
                <a :href="`/#/premium`" aria-label="Premium">
                  Premium
                </a>
                <a :href="playerUrl" aria-label="Web Player">Web Player</a>
                <a :href="`/#/mobile-app`" aria-label="Mobile App">Mobile App</a>
              </div>
              <div class="footer-nav">
                <span class="fn-title">Help</span>
                <a :href="mv_url + '/terms-and-conditions'" aria-label="Terms of Use"
                >Terms of Use
                </a>
                <a :href="mv_url + '/privacy-policy'" aria-label="Privacy Policy"
                >Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-top-right">
          <span class="subs-title">Subscribe to Our Newsletter</span>
          <p class="subs-desc">
            Subscribe to our newsletter to get the latest promo, release
            updates, and missions project!
          </p>
          <div class="subs-form">
            <input
              type="text"
              placeholder="Email"
              v-model="form.email_subscribe"
              :disabled="isSending"
            />
            <button
              type="button"
              id="mc-embedded-subscribe"
              class="btn-n primary"
              @click="onSubmitJoin"
              :disabled="isSending || form.email_subscribe === ''"
            >
              {{ isSending ? "Sending..." : "Subscribe" }}
            </button>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-nav footer-nav-social">
          <span class="fn-title">CONNECT WITH US</span>
          <div class="fn-socials">
            <a href="mailto:info@musicverse.org" aria-label="Mail">
              <img src="@/assets/mail-icon-n.svg" alt="icon mail" />
            </a>
            <a
              href="https://www.instagram.com/musicverseinternational/?hl=en"
              aria-label="Instagram"
            >
              <img src="@/assets/instagram-icon.svg" alt="ig icon" />
            </a>
            <a
              href="https://www.facebook.com/musicverse.org"
              aria-label="Facebook"
            >
              <img src="@/assets/fb-icon-n.svg" alt="fb icon" />
            </a>
            <a href="https://twitter.com/MusicVerseIntl" aria-label="Twitter">
              <img src="@/assets/twitter-icon.svg" alt="twitter icon" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCjRCshDsxtam7Wh9SIKLuHA"
              aria-label="Youtube"
            >
              <img src="@/assets/youtube-icon.svg" alt="youtube icon" />
            </a>
          </div>
        </div>
        <span>©MusicVerse. 2023. All rights reserved.</span>
      </div>
    </div>
    <div class="toastr" v-if="showToast">
      <div class="toastr-container">
        <div class="toastr-body">
          <img :src="toastType === 'success' ? successIcon : errorIcon" />
          <div class="toastr-content">
            {{ toastMsg }}
          </div>
        </div>
        <button class="toastr-close" type="button" aria-label="close" @click="showToast = false">x</button>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import successIcon from '@/assets/success-icon.svg'
import errorIcon from '@/assets/error-icon.svg'

const API_URL = process.env.API_URL;
export default {
  name: 'FooterLandingNew',
  data() {
    return {
      playerUrl: process.env.PLAYER_URL,
      dashboardUrl: process.env.DASHBOARD_URL,
      mv_url: process.env.MUSICVERSE_URL,
      showToast: false,
      toastType: 'success',
      toastMsg: '',
      form: {
        email_subscribe: "",
        recaptcha: "",
      },
      isSending: false,
      successIcon,
      errorIcon
    };
  },
  methods: {
    async onSubmitJoin() {
      if (this.form.email_subscribe === "") {
        return;
      }
      this.isSending = true;
      try {
        const res = await axios.post(`${API_URL}/subscribe-newsletter`, {
          email: this.form.email_subscribe,
        });
        this.toastMsg = res.data.message;
        this.toastType = 'success';
        this.showToast = true;
        setTimeout(()=>{
          this.showToast = false;
        }, 3000)
        this.$nextTick(() => {
          // (this.$refs.vueRecaptcha as any).reset();
          this.form = {
            email_subscribe: "",
            recaptcha: "",
          };
          this.isSending = false;
        });
      } catch (e) {
        this.toastMsg = e.response.data.message;
        this.toastType = 'error';
        this.showToast = true;
        setTimeout(()=>{
          this.showToast = false;
        }, 3000)
        this.isSending = false;
      }
    },
    toAbout() {
      window.location.href = this.mv_url+'/about-us';
    },
    toMusicians() {
      window.location.href = this.mv_url+'/musicians';
    },
  }
};
</script>

<style scoped>
  @import '../assets/stylesheets/footer.css';
</style>



// WEBPACK FOOTER //
// src/components/FooterLandingNew.vue